module.exports = __webpack_public_path__ + "dashboard/img/prezentacja.5614bb92fd48aa987892b4ea8353ee6c.svg";